import { IApplicationState } from '../../types/redux';

export const selectOffersCountFetching = (state: IApplicationState): boolean => {
  return state.filters.offersCount.isFetching;
};
